<template>
    <div class="main-wrapper no-padding scroll-y custom-scrollbar view-academy-single">

        <academy-segment></academy-segment>

        <slide-x-left-transition :duration="800" :delay="200">
            <div v-if="show && single" style="position: relative;">
                <router-link v-show="single.registration_available"
                             :to="{ name: 'AcademyRegister', params: { slug: this.$route.params.slug }}">
                    <ion-button mode="ios" size="big" style="position: absolute; top:70%; left: 50%; transform: translate(-50%, -70%);">Zarejestruj się</ion-button>
                </router-link>
                <ion-skeleton-text v-if="loading" animated style="width: 100%; height: 220px; margin: 0"></ion-skeleton-text>
                <img v-else :src="single.image" class="rwd-image"/>
            </div>
        </slide-x-left-transition>

        <div class="inner-padding">
            <slide-y-up-transition :duration="600" :delay="200">
                <div v-if="show && single">
                    <h3>{{ single.subtitle }}</h3>
                </div>
            </slide-y-up-transition>
            <slide-y-up-transition :duration="700" :delay="300">
                <div v-if="show && single" v-html="single.description"></div>
            </slide-y-up-transition>
            <hr/>

            <!--TODO: no backend-->
            <!--<slide-y-up-transition :duration="500" :delay="300">-->
                <!--<div v-if="show">-->
                    <!--<h3>Etapy akademii TODO:</h3>-->
                <!--</div>-->
            <!--</slide-y-up-transition>-->
            <!--<ion-list style="background: #f2f2f2">-->
                <!--<slide-x-left-transition :duration="600" :delay="400">-->
                    <!--<ion-item v-show="show" mode="ios">-->
                        <!--<ion-thumbnail>-->
                            <!--<h3>1.</h3>-->
                        <!--</ion-thumbnail>-->
                        <!--<ion-label mode="md" class="ion-text-wrap">-->
                            <!--<h3>Rejestracja</h3>-->
                            <!--<p>Żeby dostać się do Akademii Barmańskiej Pilsner Urquell wystarczy się zarejestrować. Po rejestracji wyślemy do Ciebie wiadomość z informacją o miejscu i terminie warsztatów!</p>-->
                        <!--</ion-label>-->
                    <!--</ion-item>-->
                <!--</slide-x-left-transition>-->
                <!--<slide-x-left-transition :duration="600" :delay="400">-->
                    <!--<ion-item v-show="show" mode="ios">-->
                        <!--<ion-thumbnail>-->
                            <!--<h3>2.</h3>-->
                        <!--</ion-thumbnail>-->
                        <!--<ion-label mode="md" class="ion-text-wrap">-->
                            <!--<h3>Warsztaty</h3>-->
                            <!--<p>Podczas warsztatów poznasz tajniki degustacji, techniki serwowania na czeskie sposoby oraz wymienisz doświadczenia z pasjonatami i barmanami z całej Polski.</p>-->
                        <!--</ion-label>-->
                    <!--</ion-item>-->
                <!--</slide-x-left-transition>-->
                <!--<slide-x-left-transition :duration="700" :delay="400">-->
                    <!--<ion-item v-show="show" mode="ios">-->
                        <!--<ion-thumbnail>-->
                            <!--<h3>3.</h3>-->
                        <!--</ion-thumbnail>-->
                        <!--<ion-label mode="md" class="ion-text-wrap">-->
                            <!--<h3>Finał</h3>-->
                            <!--<p>Finałowa rozgrywka o Tytuł Mistrza Barmańskiego Pilsner Urquell i wysokie nagrody pieniężne. Spośród finalistów wybierzemy 3 zwycięzców!</p>-->
                        <!--</ion-label>-->
                    <!--</ion-item>-->
                <!--</slide-x-left-transition>-->
            <!--</ion-list>-->

            <page-title :title="'Aktualności z Akademii'" :back="false"></page-title>

            <div v-for="(item,index) in news" :key="item.slug">
                <item-news
                        :index="index+1"
                        :route="{ name: 'AcademyNewsSingle', params: { slug: $route.params.slug, id: item.slug }}"
                        :slug="item.slug"
                        :badge="item.badge"
                        :title="item.title"
                        :subtitle="item.excerpt"
                        :image="item.image"
                        :date="item.date_publication">
                </item-news>
            </div>

            <ion-button mode="ios" expand="block" class="mt-10 mb-10" @click="goTo('Academies')">
                <svg class="icon icon-chevron-back-white"><use xlink:href="#icon-chevron-back-white"></use></svg>
                <span style="display: inline-block; vertical-align: middle"><strong>Wyjdź z Akademii</strong></span>
            </ion-button>

        </div>

    </div>
</template>

<script>
    import api from '@/services/Api';
    import goTo from '@/mixins/goto';
    import { mapState } from 'vuex';
    import PageTitle from '@/components/PageTitle.vue';
    import AcademySegment from '@/navs/AcademySegment';
    import ItemNews from '@/items/ItemNews';

    export default {
        name: 'AcademySingle',
        components: { PageTitle, AcademySegment, ItemNews },
        mixins: [goTo],
        data() {
            return {
                show: false
            }
        },
        computed: {
            ...mapState({
                loading: state => state.academies.loading,
                data: state => state.academies.data,
                single: state => state.academies.single,
                news: state => state.academies.news,
            })
        },
        mounted() {
            this.show = true;
            this.$store.dispatch('academies/KNOWLEDGE_ACADEMIES_SINGLE_REQUEST', this.$route.params.slug);
            this.$store.dispatch('academies/KNOWLEDGE_ACADEMIES_NEWS_REQUEST', this.$route.params.slug);
        },
    }
</script>

<style lang="scss" scoped>
    ion-item{
        --background: #f2f2f2;
    }
    ion-list{
        padding: 0;
    }
</style>